export const showTotalForTinyScreen = (): React.ReactNode => {
    return <></>;
};

export const showTotalForSmallScreen = (
    total: number,
    range: [number, number]
): React.ReactNode => {
    return (
        <>
            {range[0]}-{range[1]} of {total} <br /> items
        </>
    );
};

export const showTotalForLargeScreen = (
    total: number,
    range: [number, number]
): React.ReactNode => {
    return `${range[0]}-${range[1]} of ${total} items`;
};
